<template>
    <div class="h-toolbarBg">
        <ejs-toolbar ref="customCounterBar">
            <e-items>
                <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Pm.addCustomCounter")' :click="customCounterButtonClick" operate='create'></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Pm.modCustomCounter")' :click="customCounterButtonClick" operate='modify'></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Pm.delCustomCounter")' :click="customCounterButtonClick" operate='delete'></e-item>
            </e-items>
        </ejs-toolbar>
    </div>
</template>

<script>

    export default {
        name: "CustomCounterBar",

        props: [
            'gnbCounterTreeClickInfo'
        ],

        data() {
            return{
            }
        },

        methods: {

            // 将工具栏的点击事件分发到父级组件的 methodList 方法中
            customCounterButtonClick(args){
                this.$parent.methodList(args.item.operate);
            }
        },

        watch: {
            gnbCounterTreeClickInfo(counterTreeClickInfo){

                const clickId = counterTreeClickInfo.id;
                const msg = clickId.split('_')[1];
                if(msg != null && msg != undefined && msg != ""){
                    this.$refs.customCounterBar.enableItems([0, 1, 2], true);
                }else {
                    this.$refs.customCounterBar.enableItems([2], true);
                    this.$refs.customCounterBar.enableItems([0, 1], false);
                }
            }
        },

        mounted() {
            this.$refs.customCounterBar.enableItems([2], true);
            this.$refs.customCounterBar.enableItems([0, 1], false);
        }
    }
</script>

<style scoped>

</style>
